export const INIT = 'app/DonationGivingRulesList/INIT';
export const INIT_SUCCESS = 'app/DonationGivingRulesList/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationGivingRulesList/INIT_FAILED';
